import { render, staticRenderFns } from "./BaseErrorMessage.vue?vue&type=template&id=77e67b2c&scoped=true&lang=pug"
import script from "./BaseErrorMessage.vue?vue&type=script&lang=ts"
export * from "./BaseErrorMessage.vue?vue&type=script&lang=ts"
import style0 from "./BaseErrorMessage.vue?vue&type=style&index=0&id=77e67b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e67b2c",
  null
  
)

export default component.exports